import { AbricateList } from "./AbricateList";
import AbricateShow from "./AbricateShow";


export const abricate = {
  list: AbricateList,
  show: AbricateShow
};
